import { ThemeProvider } from "@mui/material/styles";
// eslint-disable-next-line no-restricted-imports
import { useIsRebrand } from "@src/appV2/redesign/theme/RebrandProvider";
import { type ReactElement, type ReactNode } from "react";

import { getRebrandTheme } from "./rebrandTheme";
import { getTheme } from "./theme";

const legacyTheme = getTheme("light");
const rebrandTheme = getRebrandTheme("light");

interface Props {
  children: ReactNode;
}

export function MuiThemeProvider(props: Props): ReactElement {
  const { children } = props;
  const isRebrand = useIsRebrand();

  return <ThemeProvider theme={isRebrand ? rebrandTheme : legacyTheme}>{children}</ThemeProvider>;
}
